import { PlanoBemSeguroBrandingLargeIcon } from '@angeplus/prever-component-lib';
import { usePlanDetails } from '..';

export const PlanoBemSeguroDetails: usePlanDetails = {
  name: 'Bem Seguro',
  basePrice: 84,
  title: 'Proteção e segurança para seu patrimônio',
  description:
    'Segurança patrimonial e assistências superiores para o seu lar!',
  heroUri: 'assets/img/bem-seguro.webp',
  icon: <PlanoBemSeguroBrandingLargeIcon />,
  buyButtonLabel: 'Contratar Bem Seguro',
  includedDependents: {
    description:
      'Contratante (titular), cônjuge, filhos solteiros, pais, sogros e até dois dependentes (netos ou sobrinhos), até 25 anos com dependência financeira do titular, estão incluídos no valor da mensalidade. Você ainda pode simular a adição de outros dependentes.',
    alert:
      'Além do titular deve haver ao menos 1 dependente maior de 18 anos e não curatelado.',
  },
  benefits: [
    {
      title: 'Condições para inclusão de outros dependentes.',
      items: [
        'Até 2 dependentes com grau de parentesco (neto ou sobrinho), acima de 25 anos: adicional de 10% por dependente.',
        'Até 5 dependentes com ou sem grau de parentesco até 79 anos: adicional de 30% por dependente;',
        'Dependentes adicionais a partir de 80 anos (na data de adesão do plano): adicional de 80% por dependente (exceto pais e sogros).',
      ],
    },
    {
      title: 'Cobertura e assistências',
      items: [
        'Translado até 400km',
        'Teleconsultas',
        'Orientação jurídica',
        'Acolhimento ao luto',
        'Apoio ortopédico',
        'Assistência funeral',
        'Assistência residencial com eletro',
        'Assistência auto',
        'Seguro residencial',
        'Seguro mobilidade emergencial',
      ],
    },
    {
      title: 'Beneficiários',
      description:
        'Pai, mãe, sogro, sogra, filhos solteiros e até dois dependentes com grau de parentesco (neto ou sobrinho), até 25 anos incluso no valor da mensalidade, desde que residam sob dependência financeira do titular.',
    },
    {
      title: 'Assistência funeral',
      items: [
        'Cobertura nacional',
        'Atendimento funerário 24 horas',
        'Assessoria para realização do funeral',
        'Urna com alça varão e visor',
        'Ornamentação de urna',
        'Paramentos para cerimônia fúnebre',
        'Tanatopraxia inclusa',
        'Coroa de flores com faixa de homenagem',
        'Orientação do processo de Registro de Óbito',
        'Veículo para remoção',
        'Translado incluso em raio de 400km de distância',
        'Local para velório',
        'Carência de 24 horas para morte acidental',
        'Carência de 90 dias para óbito na Região Sul',
        'Carência de 12 meses para óbito fora da Região Sul',
      ],
    },
    {
      title: 'Benefícios Exclusivos nas Capelas Prever Angelus',
      description:
        'Estruturas exclusivas para prestar as últimas homenagens de maneira digna. Estamos presentes em toda região sul com mais de 100 salas para velórios que contam com:',
      items: [
        'Equipes de apoio durante a realização do velório;',
        'Salas de descanso reservadas;',
        'Segurança e monitoramento 24h;',
        'Serviço de copa (exclusivo nas capelas Prever Angelus);',
        'Equipe de apoio durante o velório;',
        'Velório Online nas unidades onde possuímos tal serviço.',
      ],
    },
    {
      title: 'Assistência Sepultamento',
      description:
        'Titular ou dependentes do plano podem optar, caso desejarem, pela cremação ou locação trienal de jazigo. Nas cidades onde a contratada não possua cemitérios e crematórios próprios ou parceiros indicados, o associado terá direito há uma cobertura de até R$ 3.000,00 (três mil reais), para locação de jazigo ou cremação. Benefício não incluído no plano. Consulte as condições para a adesão da Assistência Sepultamento.',
      items: [],
      alert: '',
    },
    {
      title: 'Proteção pet',
      description:
        'Apenas R$15,00 mensais por pet adicionados ao valor da mensalidade do plano Prever Angelus. Finalize o ciclo do seu pet com os cuidados do Plano Prever Angelus. Adquira esse benefício através da nossa Central de Atendimento pelo fone 0800 006 6688.',
      items: [],
    },
    {
      title: 'Benefícios em vida',
      description:
        'Além da assistência funeral, você garante benefícios em vida para aproveitar melhor os dias, sem se preocupar.',
      items: [
        {
          title: 'Desconto em medicamentos',
          description:
            'Aproveite mais de 2.000 medicamentos com até 80% de desconto na rede de Farmácias credenciadas!',
        },
        {
          title: 'Clube de vantagens',
          description:
            'O Clube de vantagens Angeplus oferece para todos os associados descontos e vantagens para comprar e vender com economia. É fácil, rápido e gratuito!',
        },
      ],
    },
    {
      title: 'Assistência residencial com eletro',
      items: [
        'Assistência de chaveiro: conserto definitivo ou provisório da porta de acesso à residência ou confecção de chave.',
        'Assistência hidráulica: solução de problemas de vazamentos em tubulações aparentes ou solucionar problemas que possam acarretar risco de alagamento na residência.',
        'Assistência elétrica: reparos necessários para o restabelecimento da energia elétrica ou para solucionar problemas elétricos.',
        'Desentupimento de ramais: até 30 metros de tubulação (aparente ou acessível através de tampas ou grelhas removíveis) ou de caixa de gordura de até 60 litros.',
        'Limpeza de caixa de gordura: mão de obra para limpeza de caixa de gordura para casos em que pode acarretar alagamento na residência assistida.',
        'Vidraceiro: mão de obra especializada em caso de quebra de vidros de portas ou janelas externas.',
        'Limpeza da residência: mão de obra para serviços emergenciais de limpeza básica desobstruindo o local/passagem para dar condições de habitação e entrada dos moradores à residência.',
        'Mudança e guarda móveis: mão de obra para transferência de móveis e bens e posteriormente sua guarda, em caso de reparos ou reformas na residência.',
        'Cobertura provisória de telhados: cobertura provisória do telhado de até 7 metros de altura e/ou móveis expostos, quando as telhas forem danificadas e necessitarem de substituição.',
        'Mão-de-obra para conserto de eletrodomésticos de linha branca e os de linha marrom.',
      ],
    },
    {
      title: 'Assistência auto',
      items: [
        'Chaveiro: abertura do veículo e confecção de nova chave, desde que tecnicamente possível. Caso não seja possível solucionar o problema, será feita a remoção do veículo.',
        'Troca de pneus: troca de pneu ou reboque.',
        'Reboque: reboque para remoção do veículo até oficina ou concessionária mais próxima, indicada pelo usuário, no raio máximo de 100km.',
        'Pane elétrica: envio de profissional mecânico ou elétrico para conserto no local do evento.',
        'Pane seca: reboque do veículo até o posto de combustível mais próximo.',
      ],
    },
    {
      title: 'Acolhimento ao luto',
      items: [
        'Acompanhamento psicológico de aconselhamento e suporte que auxilia titulares e dependentes no processo do luto com 3 sessões remotas individuais e gratuitas.',
      ],
    },
    {
      title: 'Assistência de apoio ortopédico',
      items: [
        'Empréstimo de equipamento ortopédico gratuito por 30 dias: cadeira de banho, cadeira de rodas, andador 3 barras. Nas cidades onde a contratada possua unidade própria de atendimento.',
      ],
    },
    {
      title: 'Teleconsultas gratuitas',
      items: [
        'Através do APP Angeplus, em "Cuidados e Saúde" você tem acesso às teleconsultas gratuitas disponíveis para o seu plano. São mais de 30 especialidades médicas com acionamento ilimitado.',
      ],
    },
    {
      title: 'Orientação jurídica pós-óbito',
      items: [
        'Profissionais do Direito disponíveis para orientações sobre dúvidas legais relacionadas ao óbito.',
      ],
    },
    {
      title: 'Seguro residencial',
      items: [
        'Proteja o seu lar de imprevistos e, se você precisar, tenha tranquilidade de contar com o seguro residencial do Plano Bem Seguro.',
        'Conte com cobertura de até R$ 25.000,00 (vinte e cinco mil reais) contra incêndio, queda de raio (dentro do terreno), queda de aeronaves e explosão de qualquer natureza e adicional de até R$ 5.000,00 (cinco mil reais) para cobertura adicional contra vendaval, furacão, ciclone, tornado, granizo, fumaça, impacto de veículos e queda de aeronave.',
      ],
    },
    {
      title: 'Seguro mobilidade emergencial',
      items: [
        'Em caso de furto ou roubo do seu veículo, conte com o seguro de mobilidade para despesas de emergências com a sua locomoção.',
        'Cobertura de R$3.000,00 (três mil reais) para carro, R$1.500,00 (mil e quinhentos reais) para moto e R$500,00 (quinhentos reais) para bike.',
        'Cobertura colisão auto: em caso de colisão, o titular proprietário recebe R$ 100,00 por dia em que o veículo (automóvel) estiver na oficina para conserto. Limitado a 10 diárias. A indenização será de R$ 1.000,00 em caso de perda total do veículo.',
      ],
    },
    {
      title: 'Seguros',
      items: ['Mobilidade emergencial', 'Residencial'],
    },
  ],
};
